import { SignIn } from '@clerk/react';
import { useLocation } from 'react-router-dom';

import AuthLayout from '@/component-library/layouts/AuthLayout/AuthLayout';
import ClerkChooseOrganizationTask from '@/component-library/widgets/ClerkChooseOrganizationTask/ClerkChooseOrganizationTask';
import PathBOrgConfirmGate from '@/component-library/widgets/PathBOrgConfirmGate/PathBOrgConfirmGate';
import { isClerkChooseOrganizationTaskPath } from '@/utils/auth/clerkAuthPaths';
import { isPathBCustomOrgConfirmEnabled } from '@/utils/auth/pathBOrgConfirm';

/**
 * Do not set fallbackRedirectUrl to /dashboard — it races Clerk session tasks.
 * Org creation is handled by ClerkChooseOrganizationTask / ClerkSignedInRedirect.
 */
const ClerkSignInPage = () => {
  const location = useLocation();

  if (isClerkChooseOrganizationTaskPath(location.pathname)) {
    return (
      <AuthLayout>
        <div className="flex w-full justify-center">
          <PathBOrgConfirmGate source="sign-in">
            <ClerkChooseOrganizationTask />
          </PathBOrgConfirmGate>
        </div>
      </AuthLayout>
    );
  }

  const signIn = <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />;

  return (
    <AuthLayout>
      <div className="flex w-full justify-center">
        {isPathBCustomOrgConfirmEnabled() ? (
          <PathBOrgConfirmGate source="sign-in">{signIn}</PathBOrgConfirmGate>
        ) : (
          signIn
        )}
      </div>
    </AuthLayout>
  );
};

export default ClerkSignInPage;
